import React from "react";
import { FormattedMessage } from "react-intl";

const modalOverlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.35)",
  zIndex: 1200,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalBodyStyle = {
  background: "#fff",
  borderRadius: 8,
  boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
  padding: "28px 28px 20px 28px",
  minWidth: 280,
  maxWidth: 420,
  textAlign: "left",
};

const copyCaseNumber = async (caseNumber) => {
  if (!caseNumber) return;

  try {
    if (navigator?.clipboard) {
      await navigator.clipboard.writeText(caseNumber);
    } else {
      throw new Error("Clipboard API not available");
    }
  } catch (err) {
    const textarea = document.createElement("textarea");
    textarea.value = caseNumber;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
};

const CaseFormSuccessModal = ({
  isOpen,
  caseId,
  caseNumber,
  buttonColor,
  onClose,
  onOk,
  gid,
}) => {
  if (!isOpen) return null;

  const handleOk = typeof onOk === "function" ? onOk : onClose;
  const salesForceURL =
    gid === "ca6f18bc-c995-467e-8d88-b2bf01284b9e"
      ? "https://portal.avenhospitality.com/customerportal/s/case/"
      : "https://hospslns--sit.sandbox.my.site.com/customerportal/s/case/";

  return (
    <div style={modalOverlayStyle}>
      <div style={modalBodyStyle}>
        <div style={{ marginBottom: 12, fontSize: 22, fontWeight: 600 }}>
          <FormattedMessage
            id="caseform.success.title"
            defaultMessage="Case Created"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <FormattedMessage
            id="caseform.success.message"
            defaultMessage="Your case has been created successfully."
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 12,
            marginBottom: 8,
          }}
        >
          <strong style={{ minWidth: 110 }}>
            <FormattedMessage
              id="caseform.success.caseNumber"
              defaultMessage="Case Number:"
            />
          </strong>
          <span style={{ fontSize: 18, fontWeight: 500, letterSpacing: 0.5 }}>
            {caseNumber !== "" && caseId !== "" ? (
              <a
                href={`${salesForceURL}${caseId}/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {caseNumber}
              </a>
            ) : (
              caseNumber
            )}
          </span>
          {caseNumber !== "" && (
            <span
              title="Copy case number"
              onClick={() => copyCaseNumber(caseNumber)}
              style={{
                cursor: "pointer",
                color: "#007bff",
                display: "inline-flex",
                alignItems: "center",
                padding: "2px 6px",
                borderRadius: 4,
                transition: "background 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#e6f0fa")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ verticalAlign: "middle" }}
              >
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </span>
          )}
        </div>
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleOk}
            style={
              buttonColor
                ? {
                    backgroundColor: buttonColor,
                    borderColor: buttonColor,
                    color: "#fff",
                  }
                : undefined
            }
          >
            <FormattedMessage id="caseform.success.ok" defaultMessage="OK" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CaseFormSuccessModal;
